//This component will  handle slider for Percentile/Absolute values
import React from "react";
import reqwest from "reqwest";
import "../css/Sliderlo.css";
import { Table, Tabs, Card, Tag, Badge, Modal, List, Button, Avatar, message, Typography, Statistic, Tooltip,Spin } from "antd";
import { connect } from "react-redux";
import { activateDatadic, activateDatadicbackup, activateFiname, activateChange, activateScreen, activateRecord, activatePath,
   activateGoing, activateRecordtb, activateStocks, activateUnivid,activateUnivname,activateUnivtype } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined, PlusOutlined, CheckCircleTwoTone, ExclamationCircleOutlined,LoadingOutlined } from "@ant-design/icons";

const { confirm } = Modal;

class Myportfolioclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.myRef2 = React.createRef();

    this.state = {
      filtermt: this.props.filtermt,
      pass: this.props.pass,
      visible: true,

      data: [],
      loadmod: false,
      loading: false,
      tipmsg:'',
      loadtip:false,
    };
    
  }










  addToPortfilter(id,name) {
    this.props.activateScreen(true);
    this.setState({
      lookingTickers: true,
      runscreen: true,
      loading: true,
    });

    
    this.props.activateUnivid(id);
    this.props.activateUnivname('My Portfolio: '+name);
    this.props.activateUnivtype(1);
    
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tables: [this.props.datadic.FilterDic], portfolioId: id
      }),
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>

     
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen: false,
            count: 60,
            loadmod:false,
            loading: true,
            visible: true,
          },
          () => {

            this.props.activateScreen(false);
            this.props.activateRecord(data.filteredData.length);
            this.props.activateRecordtb(data.filteredData.length);
            console.log(11111111)
            this.setState({ count: 100 });
            this.props.activateStocks(data.filteredData);
            if (id ==0) {
            this.setState({
              loadtip: false,
        
            });
          }
            // this.props.activateChange('');
          }
        )
      )
      .then((data) =>  console.log(2222222))
      .catch((error) => {
        this.setState(
          {
            lookingTickers: false,
            
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
            this.setState({
              loadtip: false,
        
            });
            this.setState({
              runscreen: false,
        
            });
            this.setState({
              loading: false,
        
            });
            
            this.setState({
              loadmod: false,
        
            });
           
       
            console.log(3333333)
          }
        );
      });


  }





 

  

  resetuniv = () => {
    this.setState({
      loadtip: true,
      tipmsg:'Reseting to full stock universe..'
    });

    this.props.activateUnivid(0);
    this.props.activateUnivname('');
    this.addToPortfilter(0,'') ;
    this.props.activateFiname("Untitled New Screen")
  }

  
  handleCancel = () => {
    this.setState({
      loadmod: false,
      tipmsg:''
    });
  }
  openmyport = () => {
    //console.log(id.target)
    this.setState({
      loadmod: true,
      loading: true,
    });
    reqwest({
      url: this.props.apppath + "/include/api/myportfolio/loadport.cfm?uid=" + this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {

      if (data.response != '') {

        this.setState({
          data2: data,
          loading: false,

        });
      } else {
        this.setState({
          loadmod: false,
          loading: false,
        });
        confirm({
          title: 'Create a portfolio?',
          icon: <ExclamationCircleOutlined />,
          content: 'Sorry, but you do not have any saved portfolio. Please go to My Portfolio to first create and save a portfolio.',
          okText: 'Go to My Portfolio',
          onOk() {
            // this.hidemyportpopUp();
            window.open("/myportfolio/myportview?vid=1", "_blank");
          },
          onCancel() {
            console.log('Cancel');
          },
        });


      }



    });
  }







  render() {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    return (
      <div    >
        {this.state.data2 != "" ?
          <Modal
            title="Click to Load Portfolio"
            visible={this.state.loadmod}

            onCancel={this.handleCancel}
            footer={[
              <Button key="back" type="primary" onClick={this.handleCancel}>
                Close
              </Button>,
            ]}
          >  <Card bordered={true} className="cardstyle">
              {this.state.data2 != "" ? (
                <List
                  itemLayout="horizontal"
                  dataSource={this.state.data2}
                  loading={this.state.loading}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta title={item.name} description="" avatar={item.added == 1 ? <Badge status="success" /> : <Badge status="default" />} />
                      {item.added == 1 ?
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '32px' }} />
                        : <div><Button type="primary" loading={false} onClick={() => this.addToPortfilter(item.id,item.name)}>Select</Button>
                        </div>
                      }

                    </List.Item>
                  )}
                />
              ) : (
                "looks like you don't have save filters, Add filter to save"
              )}

            </Card>
          </Modal>
          : ''}   <div className='myportbutton'>  <Button type="primary" onClick={this.openmyport}      >      Load Portfolio  </Button></div>
{this.props.univid!=0?
          <div className='myportbutton' style={{marginTop:'4px'}}> 
          <Tag color="" visible={this.state.visible} 
           onClose={() => this.setState({ visible: false  },this.resetuniv())}    closable={true}>{this.props.univname} </Tag>

         

           </div> 
:''}  <Spin tip={this.state.tipmsg} indicator={antIcon} spinning={this.state.loadtip}  style={{paddingLeft:'12px',paddingTop:'4px'}}/> 
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  datadic: state.datadic,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  change: state.change,
  screen: state.screen,
  record: state.record,
  apppath: state.apppath,
  going: state.going,
  auid: state.auid,
  recordtb: state.recordtb,
  stocks: state.stocks,
  univid: state.univid,
  univname: state.univname,
  univtype: state.univtype,

});

const mapDispatchToProps = {
  activateDatadic, activateDatadicbackup, activateFiname,
   activateChange, activateScreen, activateRecord, activatePath, activateGoing, activateRecordtb, activateStocks, activateUnivid,activateUnivname,activateUnivtype
};

const Myportfolio = connect(mapStateToProps, mapDispatchToProps)(Myportfolioclass);

export default Myportfolio;

